import React from "react";
import {
  ActionType,
  ActionTypeHelper as CommonActionTypeHelper,
} from "@xala/common-services";
import { ChooseOption } from "@xala/common-ui";

/** Action types shown in ActionProperties for header/menu/footer items (unchanged behaviour). */
export const LEGACY_ACTION_PROPERTIES_TYPES: ActionType[] = [
  ActionType.OpenScreen,
  ActionType.OpenUrl,
  ActionType.CallTo,
  ActionType.EmailTo,
];

export const BANNER_ITEM_ACTION_TYPES: ActionType[] = [
  ActionType.OpenScreen,
  ActionType.OpenUrl,
  ActionType.CallTo,
  ActionType.EmailTo,
  ActionType.OpenMedia,
  ActionType.OpenMediaCollection,
  ActionType.NoAction,
];

export const SECTION_MENU_ITEM_ACTION_TYPES: ActionType[] = [
  ActionType.OpenScreen,
  ActionType.OpenUrl,
  ActionType.OpenMedia,
  ActionType.OpenMediaCollection,
];

export class ActionTypeHelper extends CommonActionTypeHelper {
  static getOptions(
    allowedTypes: ActionType[] = LEGACY_ACTION_PROPERTIES_TYPES,
    actionTypeLabels?: Partial<Record<ActionType, string>>
  ): React.ReactElement[] {
    return allowedTypes.map((type) => (
      <ChooseOption key={type} value={type}>
        {actionTypeLabels?.[type] ?? ActionTypeHelper.getDescription(type)}
      </ChooseOption>
    ));
  }
}
